import { SEARCH_PROGRESS_KEY } from 'utils/constants';
import { removeResponseProgressLocalStorage } from 'v2/utils/dataProviderUtils';

export function onLogout() {
  localStorage.removeItem(SEARCH_PROGRESS_KEY);
  removeResponseProgressLocalStorage();
}
